import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import updateCustomSIPHeader from 'API/CustomSIPHeaders/updateCustomSIPHeader';

const useUpdateCustomSIPHeader = (formData, resetToMainTable) => {
    const { currentScope } = useSelector((state) => state.login);

    return useMutation({
        mutationFn: async () => {
            try {
                const data = await updateCustomSIPHeader(
                    formData,
                    currentScope,
                ).then((res) => {
                    toast.success('Custom SIP Header updated successfully');
                    resetToMainTable();
                    return res;
                });
                return data;
            } catch (error) {
                console.error('Error updating custom SIP header:', error);
                toast.error('Failed to update custom SIP header');
                throw error;
            }
        },
    });
};

export default useUpdateCustomSIPHeader;
